import React, { Component } from "react";
import FpgPlusIcon from "../icons/fpgplusicon";
import CatEditIcon from "../icons/catediticon";
import TextField from "./TextField";
import MultiSelect from "./MultiSelect";
import TextEditor from "./TextEditor";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//moment import
import moment from "moment-timezone";
//Validation import
import SimpleReactValidator from "simple-react-validator";
//Service import
import service from "../services";
import Loader from "./loader";
import DropdownMaster from "./DropdownMaster";
import LoaderSvg from "../assets/images/loader.svg";
import ProductCompareBenefits from "./ProductCompareBenefits";

// Fields carried over unchanged from the product detail into the update
// payload, so saving benefits from this modal never alters other product data.
const PRODUCT_PASSTHROUGH_FIELDS = [
  "name", "summary", "desc", "price", "earlyPrice", "earlyPriceText", "label", "accessType",
  "status", "hideFromLive", "eventiveId", "eventiveCode",
  "earlyPriceStartDate", "earlyPriceEndDate", "earlyAccessStartDate", "earlyAccessEndDate",
  "publicSalesStartDate", "publicSalesEndDate", "waitListStartDate", "waitListEndDate",
  "earlyAccess2StartDate", "earlyAccess2EndDate", "earlyAccess3StartDate", "earlyAccess3EndDate",
  "myLibraryType", "waitlistType", "isByPass", "isGiftable", "validScreeningTypes",
  "membershipTypes", "membership2Types", "membership3Types", "productClassification", "sponsorName",
];

const PRODUCT_TYPE_OPTIONS = [
  { label: "In-Person", value: "1" },
  { label: "Online", value: "2" },
];

const SUBTITLE_TABS = [
  { name: "Compare Benefits", value: "compareBenifitsSubtitle" },
  { name: "Compare Benefits - In-person", value: "compareBenefitsInPersonSubtitle" },
  { name: "Compare Benefits - Online", value: "compareBenefitsOnlineSubtitle" },
  { name: "Compare Benefits - In-person Footnote", value: "compareBenefitsInPersonFootnote" },
  { name: "Compare Benefits - Online Footnote", value: "compareBenefitsOnlineFootnote" },
];

const htmlToEditor = (html) => {
  if (!html) return EditorState.createEmpty();
  const { contentBlocks, entityMap } = htmlToDraft(html);
  if (!contentBlocks) return EditorState.createEmpty();
  return EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap));
};

const editorToHtml = (editorState) => {
  const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  return html === "<p></p>\n" || html === "<p></p>" ? "" : html;
};

let sub;
class BenefitsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addModal: false,
      isEdit: false,
      loaderFlag: false,
      benefitName: "",
      productType: [],
      hideBenefit: false,
      benefitId: "",
      benefitList: [],
      ticketHomeId: "",
      lastUpdatedAt: null,
      editPageModal: false,
      selectedSubtitleTab: SUBTITLE_TABS[0].value,
      subtitleEditors: {},
      subtitleInitial: {},
      ticketHomeDoc: null,
      productBenefitModal: false,
      productLoading: false,
      productListLoaded: false,
      productList: [],
      selectedProductId: "",
      selectedProduct: null,
      productBenefits: [],
      showProductInCompareBenefits: true,
      productBenefitsChanged: false,
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        productType: {
          message: "The product type field is required.",
          rule: (val) => Array.isArray(val) && val.length > 0,
          required: true,
        },
      },
    });
    this.apiserve = new service();
  }

  componentDidMount = () => {
    this.getAllBenefits();
    this.getBenefitsEvent();
    this.apiserve.sendevent("ticketCms|ticketHome|getList", {});
    this.apiserve.sendevent("ticketCms|products|getList", { page: 1, limit: 500 });
    this.setState({ loaderFlag: true });
  };

  componentWillUnmount = () => {
    if (sub) sub.unsubscribe();
  };

  getBenefitsEvent = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|benefits|getList":
          if (!response.error) {
            const doc = response.data || {};
            const benefits = doc.benefits || [];
            const latest = benefits.reduce(
              (acc, cur) => (!acc || moment(cur.lastUpdated).isAfter(acc.lastUpdated) ? cur : acc),
              null
            );
            this.setState({
              benefitList: benefits,
              ticketHomeId: doc._id || "",
              lastUpdatedAt: latest?.lastUpdated || null,
            });
          }
          this.setState({ loaderFlag: false });
          break;
        case "ticketCms|ticketHome|getList":
          if (!response.error) {
            const home = response.data?.docs?.[0] || null;
            const editors = {};
            const initial = {};
            SUBTITLE_TABS.forEach(({ value }) => {
              const html = home?.[value] ?? "";
              editors[value] = htmlToEditor(html);
              initial[value] = html;
            });
            this.setState({ ticketHomeDoc: home, subtitleEditors: editors, subtitleInitial: initial });
          }
          break;
        case "ticketCms|products|getList":
          if (!response.error) {
            const docs = response.data?.docs || [];
            // "Public" products only (the Product Group shown as "Public" in the Products list).
            const productList = docs.filter(
              (p) =>
                p.group === "newTicketing" &&
                (!p.userGroup || p.userGroup === "general") &&
                // Benefits only exist for In-Person / Online, so Gala products have nothing to configure.
                (p.type === "inperson" || p.type === "online")
            );
            this.setState({ productList, productListLoaded: true });
            // Modal was opened before the list arrived: preselect the first product now.
            if (this.state.productBenefitModal && !this.state.selectedProductId && productList[0]) {
              this.loadProduct(productList[0]._id);
            }
          } else {
            this.setState({ productListLoaded: true });
          }
          break;
        case "ticketCms|products|getDetail":
          if (!this.state.productBenefitModal) break;
          if (response.error) {
            this.setState({ productLoading: false, errorMsg: true, errorMsgShow: response.data?.error });
          } else {
            this.setState({
              productLoading: false,
              selectedProduct: response.data,
              productBenefits: response.data.productBenefits || [],
              showProductInCompareBenefits: response.data.showProductInCompareBenefits !== false,
              productBenefitsChanged: false,
            });
          }
          break;
        case "ticketCms|products|update":
          if (!this.state.productBenefitModal) break;
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error });
          } else {
            this.closeProductBenefitModal();
            this.apiserve.success("Product benefits updated successful.");
          }
          break;
        case "ticketCms|benefits|updatePage":
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data.error });
          } else {
            this.setState({ editPageModal: false, loaderFlag: false });
            this.apiserve.success("Page updated successful.");
            this.apiserve.sendevent("ticketCms|ticketHome|getList", {});
          }
          break;
        case "ticketCms|benefits|create":
          if (response.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.CloseModal();
            this.apiserve.success("Benefit added successful.");
            this.getAllBenefits();
          }
          break;
        case "ticketCms|benefits|edit":
          if (response.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.CloseModal();
            this.apiserve.success("Benefit updated successful.");
            this.getAllBenefits();
          }
          break;
      }
    });
  };

  getAllBenefits = () => {
    this.apiserve.sendevent("ticketCms|benefits|getList", {});
  };

  AddBenefit = () => {
    this.validator.hideMessages("");
    this.setState({
      addModal: true,
      isEdit: false,
      benefitName: "",
      productType: [],
      hideBenefit: false,
      benefitId: "",
    });
  };

  editBenefit = (item) => {
    this.validator.hideMessages("");
    const selectedTypes = Array.isArray(item.productType) ? item.productType : [item.productType];
    this.setState({
      addModal: true,
      isEdit: true,
      benefitName: item.benefitName,
      productType: PRODUCT_TYPE_OPTIONS.filter((opt) => selectedTypes.includes(opt.value)),
      hideBenefit: !!item.hideBenefit,
      benefitId: item._id,
    });
  };

  CloseModal = () => {
    this.setState({
      addModal: false,
      isEdit: false,
      benefitName: "",
      productType: [],
      hideBenefit: false,
      benefitId: "",
      loaderFlag: false,
    });
    this.validator.hideMessages("");
  };

  onInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  onProductTypeChange = (selected) => {
    this.setState({ productType: selected || [] });
  };

  onHideBenefitChange = (e) => {
    this.setState({ hideBenefit: e.target.checked });
  };

  submitFn = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const { benefitName, productType, hideBenefit, benefitId, ticketHomeId } = this.state;
      const productTypeValues = productType.map((opt) => opt.value);
      if (benefitId) {
        this.apiserve.sendevent("ticketCms|benefits|edit", {
          id: ticketHomeId,
          benefitId,
          benefitName: benefitName,
          productType: productTypeValues,
          hideBenefit: hideBenefit,
        });
      } else {
        this.apiserve.sendevent("ticketCms|benefits|create", {
          id: ticketHomeId,
          benefitName: benefitName,
          productType: productTypeValues,
          hideBenefit: hideBenefit,
        });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  openEditPage = () => {
    const { subtitleInitial } = this.state;
    const editors = {};
    SUBTITLE_TABS.forEach(({ value }) => {
      editors[value] = htmlToEditor(subtitleInitial[value]);
    });
    this.setState({ editPageModal: true, subtitleEditors: editors, selectedSubtitleTab: SUBTITLE_TABS[0].value });
  };

  closeEditPage = () => {
    this.setState({ editPageModal: false });
  };

  onSubtitleEditorChange = (editorState) => {
    this.setState((prev) => ({
      subtitleEditors: { ...prev.subtitleEditors, [prev.selectedSubtitleTab]: editorState },
    }));
  };

  isSubtitleChanged = () => {
    const { subtitleEditors, subtitleInitial } = this.state;
    return SUBTITLE_TABS.some(
      ({ value }) => subtitleEditors[value] && editorToHtml(subtitleEditors[value]) !== (subtitleInitial[value] || "")
    );
  };

  saveEditPage = () => {
    const { ticketHomeDoc, subtitleEditors } = this.state;
    if (!ticketHomeDoc?._id) return;
    const payload = { id: ticketHomeDoc._id };
    SUBTITLE_TABS.forEach(({ value }) => {
      payload[value] = editorToHtml(subtitleEditors[value]);
    });
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("ticketCms|benefits|updatePage", payload);
  };

  openProductBenefitModal = () => {
    this.setState({
      productBenefitModal: true,
      selectedProductId: "",
      selectedProduct: null,
      productBenefits: [],
      showProductInCompareBenefits: true,
      productBenefitsChanged: false,
    });
    // Preselect the first product so the dropdown never opens empty.
    const first = this.state.productList[0];
    if (first) this.loadProduct(first._id);
  };

  closeProductBenefitModal = () => {
    this.setState({
      productBenefitModal: false,
      selectedProductId: "",
      selectedProduct: null,
      productBenefits: [],
      productBenefitsChanged: false,
      productLoading: false,
      loaderFlag: false,
    });
  };

  loadProduct = (productId) => {
    this.setState({ selectedProductId: productId, selectedProduct: null, productBenefits: [], productLoading: true });
    this.apiserve.sendevent("ticketCms|products|getDetail", { productId });
  };

  onProductSelect = (e) => {
    this.loadProduct(e.target.value);
  };

  onProductBenefitsChange = (productBenefits) => {
    // The child re-emits on hydration, so compare against the saved value
    // instead of treating every emit as a user edit.
    this.setState((prev) => ({
      productBenefits,
      productBenefitsChanged:
        JSON.stringify(productBenefits) !== JSON.stringify(prev.selectedProduct?.productBenefits || []) ||
        prev.showProductInCompareBenefits !== (prev.selectedProduct?.showProductInCompareBenefits !== false),
    }));
  };

  onShowInGridChange = (showProductInCompareBenefits) => {
    this.setState((prev) => ({
      showProductInCompareBenefits,
      productBenefitsChanged:
        JSON.stringify(prev.productBenefits) !== JSON.stringify(prev.selectedProduct?.productBenefits || []) ||
        showProductInCompareBenefits !== (prev.selectedProduct?.showProductInCompareBenefits !== false),
    }));
  };

  saveProductBenefits = () => {
    const { selectedProduct, selectedProductId, productBenefits, showProductInCompareBenefits } = this.state;
    if (!selectedProduct) return;
    const payload = { productId: selectedProductId };
    PRODUCT_PASSTHROUGH_FIELDS.forEach((field) => {
      if (selectedProduct[field] !== undefined) payload[field] = selectedProduct[field];
    });
    payload.productBenefits = productBenefits;
    payload.showProductInCompareBenefits = showProductInCompareBenefits;
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("ticketCms|products|update", payload);
  };

  validateModel = () => {
    this.setState({ errorMsg: false });
  };

  render() {
    const { benefitList, lastUpdatedAt } = this.state;
    return (
      <React.Fragment>
        <div className="dashboard_header with_btn pl_15">
          <div className="searchBlock">
            <span>Benefits</span>
          </div>
          <div className="button_block admin_user_twoBtn" style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className="head_btn pointer no_border"
              onClick={this.openEditPage}
              style={{ minWidth: "140px" }}
            >
              Edit Page
            </button>
            <button
              type="button"
              className="head_btn pointer no_border"
              onClick={this.openProductBenefitModal}
              style={{ minWidth: "140px" }}
            >
              Edit Product Benefit
            </button>
          </div>
        </div>
        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt pl_15 pr_15">
          <span></span>
          {lastUpdatedAt && (
            <p className="update_date">
              Last Update: {moment.tz(lastUpdatedAt, "US/Mountain").format("h:mm A")} -{" "}
              {moment.tz(lastUpdatedAt, "US/Mountain").format("MM/DD/YYYY")}
            </p>
          )}
        </div>
        <div className="cat_outer_content">
          <div className="category_add_edit category_column">
            <div className="category_header relative d_flex">
              <p>Benefit Name</p>
              <p>Product Type</p>
              <span className="add_icon d_flex" onClick={this.AddBenefit}>
                <FpgPlusIcon width="16" height="16" color="#ffffff" stroke="#4F4F4F" />
              </span>
            </div>
            <div className="list_wrap striped_droppable_table">
              <ul>
                {benefitList?.map((item) => (
                  <li className="d_flex d_flex_align_center" key={item._id}>
                    <div className="cat_name d_flex">
                      <p className="">{item.benefitName}</p>
                      <p className="display_name">
                        {PRODUCT_TYPE_OPTIONS.filter((opt) =>
                          (Array.isArray(item.productType) ? item.productType : [item.productType]).includes(opt.value)
                        )
                          .map((opt) => opt.label)
                          .join(", ")}
                      </p>
                    </div>
                    <div className="action d_flex d_flex_align_center">
                      <span className="cat_edit pointer" onClick={() => this.editBenefit(item)}>
                        <CatEditIcon />
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Add/Edit popup */}
        <div className={`user_popup ${this.state.addModal ? "active" : ""}`}>
          <span className="popup_overlay" onClick={this.CloseModal}></span>
          <div className="cat_modal_inner">
            <p className="cat_title text_center">
              {this.state.isEdit ? "Edit Benefit" : "Add Benefit"}
            </p>
            <form>
              <div className="field_row horizontal_field d_flex">
                <TextField
                  type="text"
                  label="Benefit Name"
                  name="benefitName"
                  value={this.state.benefitName}
                  onChange={this.onInputChange}
                  fpgerror={this.validator.message("Benefit Name", this.state.benefitName, "required")}
                />
              </div>
              <div className="field_row horizontal_field d_flex">
                <MultiSelect
                  label="Product Type"
                  name="productType"
                  value={this.state.productType}
                  onChange={this.onProductTypeChange}
                  options={PRODUCT_TYPE_OPTIONS}
                  DefaultOption={"Select Product Type"}
                  fpgerror={this.validator.message("Product Type", this.state.productType, "productType")}
                />
              </div>
              <div className="field_row horizontal_field d_flex">
                <div className="field_row_inner" style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ margin: 0, marginRight: "10px" }}>Hide Benefit</label>
                  <input
                    type="checkbox"
                    id="hideBenefit"
                    name="hideBenefit"
                    checked={this.state.hideBenefit}
                    onChange={this.onHideBenefitChange}
                    style={{ width: "auto", height: "auto", margin: 0 }}
                  />
                </div>
              </div>
              <div className="cat_btns text_center">
                <button type="button" onClick={this.CloseModal}>
                  CANCEL
                </button>
                <button className="active" onClick={(e) => this.submitFn(e)}>
                  {this.state.isEdit ? "UPDATE" : "SAVE"}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Edit Page popup */}
        <div className={`user_popup archives_record_popup ${this.state.editPageModal ? "active" : ""}`}>
          <span className="popup_overlay" onClick={this.closeEditPage}></span>
          <div className="cat_modal_inner" style={{ maxWidth: "530px" }}>
            <p className="cat_title text_center">Edit Page</p>
            <form>
              <div className="field_row horizontal_field">
                <div className="field_row_inner">
                  <label>Tab Subtitle</label>
                  <div className="select_field relative">
                    <select
                      value={this.state.selectedSubtitleTab}
                      onChange={(e) => this.setState({ selectedSubtitleTab: e.target.value })}
                    >
                      {SUBTITLE_TABS.map((tab) => (
                        <option key={tab.value} value={tab.value}>{tab.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="field_row horizontal_field">
                <div className="field_row_inner">
                  <label>{SUBTITLE_TABS.find((t) => t.value === this.state.selectedSubtitleTab).name}</label>
                  <div className="field_input relative editor_wrapper">
                    <TextEditor
                      name={this.state.selectedSubtitleTab}
                      editorState={this.state.subtitleEditors[this.state.selectedSubtitleTab] || EditorState.createEmpty()}
                      value={this.state.subtitleEditors[this.state.selectedSubtitleTab] || EditorState.createEmpty()}
                      onEditorStateChange={this.onSubtitleEditorChange}
                      height={"150"}
                    />
                  </div>
                </div>
              </div>
              <div className="cat_btns text_center">
                <button type="button" onClick={this.closeEditPage}>CANCEL</button>
                <button
                  type="button"
                  disabled={this.state.loaderFlag || !this.isSubtitleChanged()}
                  className={this.state.loaderFlag || !this.isSubtitleChanged() ? "" : "active"}
                  onClick={this.saveEditPage}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Edit Product Benefit popup */}
        <div className={`user_popup archives_record_popup ${this.state.productBenefitModal ? "active" : ""}`}>
          <span className="popup_overlay" onClick={this.closeProductBenefitModal}></span>
          <div className="cat_modal_inner" style={{ maxWidth: "600px" }}>
            <p className="cat_title text_center">Edit Product Benefit</p>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="field_row horizontal_field">
                <DropdownMaster
                  label="Product"
                  name="selectedProduct"
                  value={this.state.selectedProductId}
                  onChange={this.onProductSelect}
                  options={this.state.productList.map((p) => ({ _id: p._id, name: p.name }))}
                />
              </div>
              {(this.state.productLoading || !this.state.productListLoaded) && (
                <div className="product_mylib">
                  <h3>Compare Benefits</h3>
                  <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <img src={LoaderSvg} alt="Loading" style={{ width: 50, height: 50 }} />
                  </div>
                </div>
              )}
              {this.state.selectedProduct && (
                <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                  <ProductCompareBenefits
                    key={this.state.selectedProductId}
                    benefits={this.state.benefitList}
                    productType={this.state.selectedProduct.type}
                    value={this.state.productBenefits}
                    onChange={this.onProductBenefitsChange}
                    showProductInCompareBenefits={this.state.showProductInCompareBenefits}
                    onShowProductInCompareBenefitsChange={this.onShowInGridChange}
                  />
                </div>
              )}
              <div className="cat_btns text_center">
                <button type="button" onClick={this.closeProductBenefitModal}>CANCEL</button>
                <button
                  type="button"
                  disabled={this.state.loaderFlag || !this.state.selectedProduct || !this.state.productBenefitsChanged}
                  className={this.state.loaderFlag || !this.state.selectedProduct || !this.state.productBenefitsChanged ? "" : "active"}
                  onClick={this.saveProductBenefits}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default BenefitsList;
